import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSupportAuth } from "../context/SupportAuthContext";

const WaitingApproval = () => {
  const { status, requestMeta, supportEmail, token, checkApprovalStatus, startApprovalTracking } =
    useSupportAuth();

  useEffect(() => {
    console.log("[SupportWaiting] mounted", {
      status,
      supportEmail,
      requestId: requestMeta?.requestId,
      hasToken: Boolean(token),
    });
    checkApprovalStatus();
    startApprovalTracking();
  }, [checkApprovalStatus, requestMeta?.requestId, startApprovalTracking, status, supportEmail, token]);

  useEffect(() => {
    console.log("[SupportWaiting] status changed:", status);
  }, [status]);

  if (status === "approved") {
    console.log("[SupportWaiting] redirecting to /support/dashboard");
    return <Navigate to="/support/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4">
      <div className="max-w-lg w-full bg-white border shadow-md rounded-lg p-8 text-center">
        <h2 className="text-2xl font-semibold mb-3">Waiting for approval...</h2>
        <p className="text-gray-600">
          Your support login request has been submitted. You will be redirected automatically once admin
          approves access.
        </p>
      </div>
    </div>
  );
};

export default WaitingApproval;

